export default __webpack_public_path__ + "static/media/defaultFilm.57e66ea6.jpeg";